import Component from '../app/component.js'
import sessionDocuments from '../plugins/session-documents.js'

export default class extends Component {
  constructor (el) {
    super(el)
    this.data = {}
  }

  init () {
    this.updateItems()

    // icons
    if (this.refs.items) {
      this.refs.items.forEach(el => {
        el.addEventListener('click', () => {
          const icon = el.querySelector('.doclist-icon');
          const id = icon.dataset.id;
          const title = icon.dataset.title;
          const type = icon.dataset.type ? icon.dataset.type : window.__productType;
          if (icon.classList.contains('doclist-icon--add')) {
            sessionDocuments.add({id, title, type});
          } else {
            sessionDocuments.remove(id);
          }
          this.updateItems();
        })
      })
    }

    sessionDocuments.addListener(() => this.updateItems());
  }

  updateItems () {
    if (this.refs.items) {
      this.refs.items.forEach(el => {
        const icon = el.querySelector('.doclist-icon')
        if (icon) {
          const id = icon.getAttribute('data-id')
          if (sessionDocuments.has(id)) {
            el.classList.add('doclist-item--active')
            icon.classList.remove('doclist-icon--add')
            icon.classList.add('doclist-icon--remove')
          } else {
            el.classList.remove('doclist-item--active')
            icon.classList.add('doclist-icon--add')
            icon.classList.remove('doclist-icon--remove')
          }
        }
      })
    }
  }
}
